import React from "react";
import { Directory, pathLookup } from "./Library";
import numeral from "numeral";
import * as _ from "lodash";
interface Props {
  card: any;
  header?: string;
  sub?: string;
  link?: string;
  pathAddition?: string;
  i?: any;
}

const libraryBase = (e: any) =>
  `https://raw.githubusercontent.com/DrewWeth/geodebugger-library/master${e}`;

function LibraryCard(props: Props) {
  const { img, name, size, url, path } = props.card;

  const imgUrl = libraryBase(img);

  return (
    <div
      className="library-card shadow"
      style={{
        background: img ? `url(${imgUrl}) bottom no-repeat` : undefined,
        backgroundSize: "cover",
        display: "relative"
      }}
    >
      <div className="library-header">{name}</div>
      <div className="library-sub">
        {!url
          ? `${(_.get(pathLookup[path], ["items"]) || []).length}, low-res`
          : size && numeral(size).format("0b")}
      </div>
    </div>
  );
}

export default LibraryCard;
